import { render, staticRenderFns } from "./policyAndLaw.vue?vue&type=template&id=a45a509a&scoped=true"
import script from "./policyAndLaw.vue?vue&type=script&lang=js"
export * from "./policyAndLaw.vue?vue&type=script&lang=js"
import style0 from "./policyAndLaw.vue?vue&type=style&index=0&id=a45a509a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45a509a",
  null
  
)

export default component.exports